import { NETWORK } from '@shared/utils/constant'
import { LocalStorage } from '@injectivelabs/utils'
import { tokenStaticFactory } from '@shared/service'
import { tokens } from '@/app/json'

export const localStorage: LocalStorage = new LocalStorage(
  `bridge-${NETWORK}-v1`
)

tokenStaticFactory.mapRegistry(tokens)
